import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService } from '../../../../../services/dialog.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../../../../utils/utils';
import { ToastrService } from 'ngx-toastr';
import { EMTControllerSoftwareRelease } from '../controllersoftwarerelease.component';

@Component({
    selector: 'createcontrollergroup-popup',
    templateUrl: './createcontrollergroup-popup.component.html',
    styleUrls: ['./createcontrollergroup-popup.component.less', '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})

export class CreateControllerGroupPopupComponent implements OnInit {

    form!: FormGroup
    submitted = false;
    contactCategories: any[] = [];
    subscriptions: any[] = [];
    buttonLabel: string = 'Create';
    buttonIcon: string = 'add';
    availableContacts: any[] = []

    constructor(
        private http: HttpClient,
        private confimDialog: DialogService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject('BASE_URL') private baseUrl: string,
        public dialogRef: MatDialogRef<CreateControllerGroupPopupComponent>,
        private formBuilder: FormBuilder,
        private toastrService: ToastrService
    )
    {
        this.confimDialog.tthis = this;
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            globalControllerGroupName: ['', Validators.required],
            confirmName: ['', Validators.required],
            softwareVersionId : [this.data.softwareVersionId],
        }, { validators: this.nameMatchValidator });
    }

    nameMatchValidator(formGroup: FormGroup) {
        const name = formGroup.get('globalControllerGroupName')?.value;
        const confirmName = formGroup.get('confirmName')?.value;
        return name && confirmName && name === confirmName ? null : { namesNotMatching: true };
    }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.form)
            if (this.form.invalid) {
                return;
            }
        Utils.httpCreateEMTGlobalControllerGroup(
            this.http
            , this.baseUrl
            , this.form.value
            , this
            , function (tthis: CreateControllerGroupPopupComponent, result: any) {
                tthis.dialogRef.close({ event: 'submit' });
                if (result)
                    tthis.toastrService.success(`Global controller group was created successfully!`);
                if (tthis.data.refreshParent) {
                    tthis.data.refreshParent();
                }
                else
                    tthis.toastrService.error(`Global controller group could not be created. There is an already existing group with the same name`);
            },
            function (tthis: CreateControllerGroupPopupComponent) {
                tthis.toastrService.error(`Global controller group could not be created.`);
            },
        );
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();

    }
    
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}